import { Box, Grid, Tab, Tabs, Typography } from "@mui/material";
import React, { useEffect } from "react";
import theme from "../../theme";
import FlashSalesAllNew from "./FlashSalesAllNew";
import FlashSalesActive from "./FlashSaleActive";
import { useLocation } from "react-router";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";
import { permissionsConstants } from "../../constants/AppConstants";

const FlashSaleNew = () => {
  const [tab, setTab] = React.useState("allFlashSale");
  const { search } = useLocation();
  const { getUserPermission: activeFlashSalesPermissions } =
    usePermissionGetter(
      permissionsConstants.flash_sale,
      permissionsConstants.active_flash_sales
    );

  const { getUserPermission: allFlashSalesPermissions } = usePermissionGetter(
    permissionsConstants.flash_sale,
    permissionsConstants.all_flash_sales
  );

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setTab(newValue);
  };
  const [tabList, setTabList] = React.useState<string[]>([]);

  React.useEffect(() => {
    if (allFlashSalesPermissions("read") && !tabList.includes("allFlashSale")) {
      setTabList((prevTabList) => [...prevTabList, "allFlashSale"]);
    }
    if (
      activeFlashSalesPermissions("read") &&
      !tabList.includes("activeFlashSales")
    ) {
      setTabList((prevTabList) => [...prevTabList, "activeFlashSales"]);
    }
  }, [activeFlashSalesPermissions, allFlashSalesPermissions]);

  React.useEffect(() => {
    if (tabList[0] !== undefined && tab !== tabList[0]) setTab(tabList[0]);
  }, [tabList]);

  useEffect(() => {
    const query = new URLSearchParams(search);
    const tabId = query.get("tab");
    if (tabId) setTab(tabId);
  }, []);
  return (
    <Grid sx={{ background: theme.color?.background }} borderRadius={2}>
      <Grid borderBottom={theme.border?.smallGrey} px={4} py={5}>
        <Typography
          sx={{
            fontWeight: theme.font?.fontWeight.thick,
            fontFamily: theme.font?.fontFamily.primary,
            fontSize: theme.font?.fontSize.large,
          }}
        >
          Flash Sales
        </Typography>
      </Grid>
      <Grid
        item
        borderBottom={`${theme?.border?.xsmall}${theme.color?.dividerLight}`}
        sx={{ background: theme.color?.background, width: "100%" }}
      >
        <Box ml={3}>
          <Tabs
            TabIndicatorProps={{
              style: {
                backgroundColor: theme.color?.secondary,
              },
            }}
            value={tab}
            onChange={handleChange}
            aria-label="tabs menu"
          >
            {allFlashSalesPermissions("read") && (
              <Tab
                value={"allFlashSale"}
                id={"allFlashSale"}
                label="All Flash Sales"
                style={{
                  textTransform: "capitalize",
                  fontFamily: theme.font?.fontFamily.primary,
                  color:
                    tab === "allFlashSale" ? theme.color?.secondary : undefined,
                }}
              />
            )}
            {activeFlashSalesPermissions("read") && (
              <Tab
                value={"activeFlashSales"}
                id={"activeFlashSales"}
                label="Active Flash Sales"
                onClick={() => setTab("activeFlashSales")}
                style={{
                  textTransform: "capitalize",
                  fontFamily: theme.font?.fontFamily.primary,
                  color:
                    tab === "activeFlashSales"
                      ? theme.color?.secondary
                      : undefined,
                }}
              />
            )}
          </Tabs>
        </Box>
      </Grid>
      <Grid px={4} py={2}>
        {tab === "allFlashSale" ? <FlashSalesAllNew /> : <FlashSalesActive />}
      </Grid>
    </Grid>
  );
};

export default FlashSaleNew;
